/* eslint-disable no-undefined */

import { differenceInCalendarDays, formatSimpleDate } from "../date-utils/DateUtils";
const sortDateUsingFilter = dialogues => {
  let currentdate = formatSimpleDate(new Date(2007, 0, 29), {
    pattern: "MM-DD-YYYY"
  });
  dialogues.map((item, key) => {
    const rdataDate = formatSimpleDate(item.created, {
      pattern: "dddd, Do MMM YYYY"
    });
    const diff = differenceInCalendarDays(new Date(), item.created);
    let res;
    if (diff < -1) {
      res = "Last Week";
    } else if (diff < 0 || diff === 1) {
      res = "Yesterday";
    } else if (diff < 1) {
      res = "Today";
    } else {
      res = rdataDate;
    }
    if (rdataDate !== currentdate) {
      dialogues[key].dateCaption = res;
      currentdate = rdataDate;
    }
  });
};
export const getLastAmbassadorDialogue = message => {
  sortDateUsingFilter(message.dialogues);
  const expertDialogues = message.dialogues.filter(({
    origin
  }) => origin === "expert");
  const hasSingleExpert = expertDialogues.length > 0 ? !!expertDialogues.reduce((last, curr) => last.userId === curr.userId ? last : NaN) : false;
  const lastDialogue = expertDialogues.length > 0 ? expertDialogues[expertDialogues.length - 1] : {};
  const expertInfo = message.expertAuthors[lastDialogue.userId];
  const thumbnail = expertInfo ? expertInfo.thumbnail : null;
  return {
    hasSingleExpert,
    lastDialogue,
    thumbnail
  };
};
export const getLastDialogue = message => {
  const lastDialogue = message.dialogues && message.dialogues.length > 0 ? message.dialogues[message.dialogues.length - 1] : {};
  let isLastDialogueAmbassador = true;
  if (lastDialogue.origin === "customer" || lastDialogue.origin === "system") {
    isLastDialogueAmbassador = false;
  }
  return {
    isLastDialogueAmbassador,
    lastDialogue
  };
};